import React from "react";
import KpiSummaryLevelThreeKpiCard from "./KpiSummaryLevelThreeKpiCard";
import PropTypes from "prop-types";

function KpiSummaryLevelThreeKpiLevel0Component(props) {
    return (
        <div style={{ margin: "1% 0%" }}>
            <div
                className="card-header"
                style={{
                    backgroundColor: "#757AF7",
                    color: "#FFFFFF",
                    fontWeight: "bold",
                    borderRadius: "0%",
                }}
            >
                Level 0 kpi&apos;s
            </div>
            <div
                className="card-body"
                style={{
                    border: "solid #753dff",
                    borderRadius: "0%",
                    padding: "0%",
                    backgroundColor: "#E0E0E0",
                }}
            >
                <div className="row" style={{ padding: "1% 1%" }}>
                    <KpiSummaryLevelThreeKpiCard
                        kpiStatusData={props.kpiStatusData.l0_collision_check}
                        loading={props.loading}
                        error={props.error}
                        kpiName={"L0 Collision Check KPI"}
                    />
                    <KpiSummaryLevelThreeKpiCard
                        kpiStatusData={props.kpiStatusData.l0_false_indicator_check}
                        loading={props.loading}
                        error={props.error}
                        kpiName={"L0 False Indicator Check KPI"}
                    />
                    <KpiSummaryLevelThreeKpiCard
                        kpiStatusData={props.kpiStatusData.l0_indicator_checking}
                        loading={props.loading}
                        error={props.error}
                        kpiName={"L0 Indicator Check KPI"}
                    />
                </div>
                <div className="row" style={{ padding: "1% 1%" }}>
                    <KpiSummaryLevelThreeKpiCard
                        kpiStatusData={props.kpiStatusData.l0_lane_marking_check}
                        loading={props.loading}
                        error={props.error}
                        kpiName={"L0 Lane Marking Check KPI"}
                    />
                    <KpiSummaryLevelThreeKpiCard
                        kpiStatusData={props.kpiStatusData.l0_lateral_safe_distance}
                        loading={props.loading}
                        error={props.error}
                        kpiName={"L0 Lateral Safe Distance KPI"}
                    />
                    <KpiSummaryLevelThreeKpiCard
                        kpiStatusData={props.kpiStatusData.l0_longitudinal_safe_distance}
                        loading={props.loading}
                        error={props.error}
                        kpiName={"L0 Longitudinal Safe Distance KPI"}
                    />
                </div>
                <div className="row" style={{ padding: "1% 1%" }}>
                    {/* <div className="col-lg-4">
                        <div
                            className="card"
                            style={{
                                border: "solid #753dff",
                                borderRadius: "0%",
                                height: "100%",
                            }}
                        >
                            <div
                                className="card-header"
                                style={{
                                    backgroundColor: "#753dff",
                                    color: "#FFFFFF",
                                    fontWeight: "bold",
                                    borderRadius: "0%",
                                }}
                            >
                                L0 Offroad Check KPI
                            </div>
                            {props.loading ? (
                                <MiniLoader />
                            ) : props.error ? (
                                <Alert key="danger" variant="danger">
                                    {props.error}
                                </Alert>
                            ) : props.kpiStatusData === undefined ? (
                                <Alert key="info" variant="info">
                                    Please select cad topology !
                                </Alert>
                            ) : Object.keys(props.kpiStatusData).length === 0 ? (
                                <Alert key="info" variant="info">
                                    No records found for this cad topology !
                                </Alert>
                            ) : (
                                <div>
                                    <KpiSummaryLevelThreeKpiCard
                                        kpiStatusData={props.kpiStatusData.l0_offroad_check_kpi}
                                    />
                                </div>
                            )}
                        </div>
                    </div> */}
                    <KpiSummaryLevelThreeKpiCard
                        kpiStatusData={props.kpiStatusData.l0_offroad_check_kpi}
                        loading={props.loading}
                        error={props.error}
                        kpiName={"L0 Offroad Check KPI"}
                    />
                    {/* <div className="col-lg-4">
                        <div
                            className="card"
                            style={{
                                border: "solid #753dff",
                                borderRadius: "0%",
                                height: "100%",
                            }}
                        >
                            <div
                                className="card-header"
                                style={{
                                    backgroundColor: "#753dff",
                                    color: "#FFFFFF",
                                    fontWeight: "bold",
                                    borderRadius: "0%",
                                }}
                            >
                                L0 Speed Limit KPI
                            </div>
                            {props.loading ? (
                                <MiniLoader />
                            ) : props.error ? (
                                <Alert key="danger" variant="danger">
                                    {props.error}
                                </Alert>
                            ) : props.kpiStatusData === undefined ? (
                                <Alert key="info" variant="info">
                                    Please select cad topology !
                                </Alert>
                            ) : Object.keys(props.kpiStatusData).length === 0 ? (
                                <Alert key="info" variant="info">
                                    No records found for this cad topology !
                                </Alert>
                            ) : (
                                <div>
                                    <KpiSummaryLevelThreeKpiCard
                                        kpiStatusData={props.kpiStatusData.l0_speed_limit_check}
                                    />
                                </div>
                            )}
                        </div>
                    </div> */}
                    <KpiSummaryLevelThreeKpiCard
                        kpiStatusData={props.kpiStatusData.l0_speed_limit_check}
                        loading={props.loading}
                        error={props.error}
                        kpiName={"L0 Speed Limit KPI"}
                    />
                </div>
            </div>
        </div>
    );
}

KpiSummaryLevelThreeKpiLevel0Component.propTypes = {
    loading: PropTypes.bool,
    error: PropTypes.string,
    kpiStatusData: PropTypes.object,
};

export default KpiSummaryLevelThreeKpiLevel0Component;
